import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import FormLabel from '@material-ui/core/FormLabel';
import React from 'react';
import Switch from '@material-ui/core/Switch';

export default function isPushNotificationToggle({ checked, onChange, label }) {
    return (
        <FormControl component="fieldset">
            <FormLabel component="legend">{label}</FormLabel>
            <FormGroup>
                <FormControlLabel
                    control={
                        <Switch checked={checked} onChange={onChange} value="isSilent" />
                    }
                    label=""
                />
            </FormGroup>
        </FormControl>
    );
}
